import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useGoogleAuthenticationMutation } from "../redux/features/auth/auth.api";
import { authSliceActions } from "../redux/features/auth/auth.slice";
import { useAppDispatch } from "../redux/hooks";

export const useSocialAuth = () => {
  const [
    googleAuth,
    {
      isLoading: authenticatingWithGoogle,
      isError: isGoogleAuthError,
      error: googleAuthError,
    },
  ] = useGoogleAuthenticationMutation();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const loginWighGoogle = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (tokenResponse) => {
      const response = await googleAuth({
        authToken: tokenResponse.access_token,
      });

      if (response.data?.status === "success") {
        dispatch(
          authSliceActions.signUserIn({
            profile: {
              ...response.data.data,
            },
            token: response.data.data.token,
          }),
        );

        navigate("/home");
      }
    },
  });

  return {
    loginWighGoogle,
    authenticatingWithGoogle,
    googleAuthError,
    isGoogleAuthError,
  };
};
